/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const actionsStyle = {
  alert: {
    minHeight: "var(--toastify-toast-min-height)",
    width: "var(--toastify-toast-width)",
    paddingRight: "3rem",
    borderLeft: "none",
    borderRadius: 0,
    alignItems: "center",
  },
};
